import { useLocalStorage } from '@hooks/useLocalStorage';
import { ImageType } from '@models/Image';

import { ImageTypeContextProps } from './useImageTypeContext/types';

const useImageType = ({ defaultImageType = 'poster', localStorageKey }: ImageTypeContextProps) => {
  const [imageType, setImageType] = useLocalStorage<ImageType>(localStorageKey, defaultImageType);
  return { imageType, setImageType };
};

export default useImageType;
